<template>
  <div class="contact-card">
    <div class="open-closed text-xs" :class="{ '-open': isOpen() }">
      <span class="open-text">{{ data.nowOpenText }}</span
      ><span class="closed-text">{{ data.closedText }}</span>
      <div class="icon" />
    </div>
    <StructuredText
      v-if="!isEmptyDocument(data.openingTimesText)"
      class="text text-md"
      :data="data.openingTimesText"
    />
    <StructuredText
      v-if="!isEmptyDocument(data.additionalText)"
      class="text text-xs"
      :data="data.additionalText"
    />
  </div>
</template>

<script lang="ts" setup>
import { type ContactCardFragment } from '#gql';
import { StructuredText } from 'vue-datocms';
import { isEmptyDocument } from 'datocms-structured-text-utils';

defineProps<{
  data: ContactCardFragment;
}>();

function isOpen() {
  const date = new Date();
  const day = date.getDay();
  const hours = date.getHours();
  return day >= 1 && day <= 5 && hours >= 9 && hours < 17;
}
</script>

<style scoped lang="scss">
.contact-card {
  background: var(--base-color-white-40);
  border-radius: var(--base-border-radius-small);
  padding: 2rem;
  display: grid;
  gap: 1.5rem;

  .open-closed {
    display: flex;
    gap: 1rem;
    .open-text {
      display: none;
    }
    .icon {
      height: 12px;
      width: 12px;
      border-radius: 50%;
      background: var(--color-pink-200);
      margin-block: auto;
    }

    &.-open {
      .closed-text {
        display: none;
      }
      .open-text {
        display: block;
      }
      .icon {
        background: var(--color-aqua-200);
      }
    }
  }
}
</style>
